import Tools from "../../../../Tools";
import {watchlistTypes} from "./actionsType";

// Select player.
export const toggleSelectPlayer = (player) => {
    return {
        type: watchlistTypes.TOGGLE_SELECT_PLAYER,
        player: player
    };
};

// Pagination.
export const setPagination = (pagination) => {
    return {
        type: watchlistTypes.SET_PAGINATION,
        pagination: pagination,
    }
};

// Search.
export const setSearchValue = (value) => dispatch => {
    dispatch({
        type: watchlistTypes.SET_TEMP_SEARCH_VALUE,
        search: value,
    });
    Tools.delay(() => dispatch({
        type: watchlistTypes.SET_SEARCH_VALUE,
        search: value,
    }), 500, watchlistTypes.SET_SEARCH_VALUE)
};

// Expand
export const setExpandRow = (row, isExpand) => {
    return {
        type: watchlistTypes.SET_EXPAND_ROW,
        row: row,
        isExpand: isExpand,
    };
};

// Order
export const setSort = (field, order) => {
    return {
        type: watchlistTypes.SET_ORDER,
        field: field,
        order: order
    }
};


// Remove selecetd players
export const removeSelectedPlayers = () => {
    return {
        type: watchlistTypes.REMOVE_SELECTED_PLAYERS,
    };
};

// Clear Selection
export const clearSelections = () => {
    return {
        type: watchlistTypes.CLEAR_SELECTIONS,
    };
};

// Clear Refetch
export const setRefetch = (shouldRefetch) => {
    return {
        type: watchlistTypes.SET_REFETCH,
        shouldRefetch,
    };
};
